import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Classroom360Service } from '../../../classroom360/classroom360.service';
import { Sped360Service } from '../../../sped360/sped360.service';
import { Portal } from '../../portal.model';
import { StudentSearchComponent } from '../../student-search/student-search.component';
import { Student } from '../../student/student.model';
import { StudentService } from '../../student/student.service';

@Component({
  selector: 'app-student-in-focus-menu',
  templateUrl: './student-in-focus-menu.component.html',
  styles: [
  ]
})
export class StudentInFocusMenuComponent implements OnInit {

  @Output() portalNavigated = new EventEmitter<void>();
  displayPortals: Portal[] = [];
  student: Student;

  constructor(
    private studentService: StudentService,
    private classroom360Service: Classroom360Service,
    private sped360Service: Sped360Service,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.studentService.selectedStudentStream$.subscribe(() => {
      this.student = this.studentService.selectedStudent;
    });

    this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(() => {
      this.displayPortals = [];
      if (this.classroom360Service.staffAssignedPortals) {
        const portals: Portal[] = JSON.parse(JSON.stringify(this.classroom360Service.staffAssignedPortals));
        const studentPortal = portals.find(o => (o.PortalName == 'Students' || o.PortalName == 'My Students') && !o.PortalDescription);
        if (studentPortal) {
          this.displayPortals = portals.filter(o => o.ParentId == studentPortal.Id);
        }
      }
    });
  }

  ngOnInit(): void {
    this.student = this.studentService.selectedStudent;
  }

  clearStudentInFocusClick() {
    if (this.router.url.indexOf('/student360') > -1 || this.router.url.indexOf('/programAndServices/singleStudent') > -1 || this.router.url.indexOf('/health360/studentHealth') > -1) {
      this.router.navigateByUrl('/classroom360/cards');
    }
    if (this.router.url == '/sped360/studentDocumentHome' || this.router.url.indexOf('/sped360/spedFormsWithinDocuments') > -1 || this.router.url.indexOf('/specialServiceEvaluations/viewEditEvaluationReport') > -1) {
      if (this.sped360Service.spedFixedPermission.ViewSpEdHome == true || this.sped360Service.spedFixedPermission.ViewSpecialServicesHome == true) {
        this.router.navigateByUrl('/sped360/spedHome');
      } else {
        const studentSearchDialogBox = this.dialog.open(StudentSearchComponent, {
          data: {
            performRoute: true,
            searchAndSelect: false,
            redirectUrl: '/sped360/studentDocumentHome'
          },
          width: '100%',
          height: '100%',
          maxHeight: '100vh',
          maxWidth: '100vw'
        });
        studentSearchDialogBox.afterClosed().subscribe(data => {
          if (data == undefined) {
            this.router.navigateByUrl('/classroom360/cards');
          }
        });
      }
    }
    this.studentService.selectedStudent = undefined;
    this.studentService.updateSelectedStudent(undefined);
  }

}
